import * as Models from './models';

export const rootDocument = (state): Models.State.IState => state.get('rootDocument');
export const rootDocumentId = state => rootDocument(state).get('documentId');
export const targetLanguage = state => rootDocument(state).get('language');
export const targetCountry = state => rootDocument(state).get('country');
export const targetProduct = state => rootDocument(state).get('product');
